export default "__VITE_ASSET__I$rxk4SX__"